import TalentDetail from './TalentDetail'
import VideoPreview from './VideoPreview.vue';

export default function install(Vue) {
  Vue.component(TalentDetail.name, TalentDetail),
  Vue.component(VideoPreview.name, VideoPreview)
}
